module.exports = __webpack_public_path__ + "img/img_案例02.29b4e819.png";